const LoadingIconRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="overflow-visible"
  >
    <style>
      {`
            @keyframes floatArrow {
              0% { transform: translateY(-8px); opacity: 0; }
              20% { transform: translateY(0); opacity: 1; }
              50% { transform: translateY(0); opacity: 1; }
              80% { transform: translateY(8px); opacity: 0; }
              100% { transform: translateY(8px); opacity: 0; }
            }

            .arrow {
              animation: floatArrow 2.5s ease-in-out infinite;
            }

            /* Left arrow starts first */
            .arrow:nth-of-type(1) {
              animation-delay: 0s;
            }

            /* Right arrow starts slightly after,
               so it overlaps before both fade out */
            .arrow:nth-of-type(2) {
              animation-delay: 0.5s;
            }
          `}
    </style>
    <g className="arrow">
      <path fill="var(--primary)" d="M4 11.998V20l8-3.998z" />
      <path fill="var(--color-97)" d="m12 8-8 3.998 8 4.004z" />
    </g>

    {/* Right arrow (two paths grouped) */}
    <g className="arrow">
      <path fill="var(--primary)" d="M20 12.002V4l-8 3.998z" />
      <path fill="var(--color-97)" d="m12 16 8-3.998-8-4.004z" />
    </g>
  </svg>
);

export default LoadingIconRight;
